import React from 'react'
import { Outlet } from 'react-router-dom'

const Vendor = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default Vendor